import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ICD10Component } from './icd10.component';


const routes: Routes = [{ path: '', component: ICD10Component }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Icd10RoutingModule { }
